import { Navigate, Outlet } from "react-router-dom";
import { isAuthenticated } from "../components/Pages/PublicLayout/SigninPage/auth"; // Your own auth check

const ProtectedRoute = () => {
  if (!isAuthenticated()) {
    return <Navigate to="/" replace />;
  }

  console.log("Access granted");
  return <Outlet />;
};

export default ProtectedRoute;